import { useCurrentUser } from '../../../modules/context/UserContext'
import { s_landing, s_menu, s_mypage_nav } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import urls from '../../../modules/urls'
import { IS_NOW_PROMO } from '../../../modules/vars'

export const useStudentMenu = () => {
  const { t, isLocaleKO } = useTranslation()
  const { currentUser } = useCurrentUser()

  const upcomingUrl =
    currentUser && currentUser.upcoming_lesson_count > 0
      ? urls.student.portal.lessons.upcomingLessons
      : urls.student.portal.lessons.scheduleEnter

  return {
    /**
     * mobile - 로그인 이후에 추가로 보여지는 메뉴
     */
    mobileAfterLogin: [
      {
        id: 'portal_welcome',
        label: 'Welcome',
        submenu: [],
        submenu2: null,
        href: urls.student.newPortal.home,
        none: false,
      },
      // 체험수업신청
      {
        id: 'portal_trial',
        label: t(s_landing.get_started),
        submenu: [],
        submenu2: null,
        href: urls.student.portal.trial.inputProfile,
        none: true,
      },
      // 구매
      {
        id: 'portal_price',
        label: t(s_menu.portal.purchase_lessons),
        href: urls.student.portal.pricing.index,
        showToolTip: IS_NOW_PROMO,
        submenu: [],
        submenu2: null,
        none: false,
      },
    ],
    portalV2: {
      leftMenu: [
        {
          id: 'menu_home',
          label: t(s_menu.portalv2.home),
          href: urls.student.newPortal.home,
          none: false,
        },
        {
          id: 'menu_conversation',
          label: t(s_menu.portalv2.conversation),
          href: upcomingUrl,
          none: false,
        },
        {
          id: 'menu_tutors',
          label: t(s_menu.conversation.tutors),
          href: urls.student.portal.tutors.recommended,
          none: false,
        },
      ],
      rightMenu: [
        {
          id: 'menu_price',
          label: t(s_menu.portal.purchase_lessons),
          href: urls.student.portal.pricing.index,
          showToolTip: false,
        },
        {
          id: 'menu_invite',
          label: t(s_menu.portal.invite),
          href: `${urls.student.portal.invite.event}`,
          showToolTip: false,
        },
      ],
      mypage: [
        {
          floor: 1,
          id: 'menu_profile',
          label: t(s_menu.mypage.my_info),
          href: urls.student.portal.mypage.profile,
          none: false,
        },
        {
          floor: 1,
          id: 'menu_credit',
          label: t(s_menu.mypage.coupon_certificates),
          href: urls.student.portal.mypage.currentCredit(0),
        },
        {
          floor: 1,
          id: 'menu_point',
          label: t(s_menu.mypage.my_point),
          href: urls.student.portal.mypage.point,
        },
        {
          floor: 1,
          id: 'menu_coupon_box',
          label: t(s_menu.mypage.coupon_box),
          href: urls.student.portal.mypage.couponBox,
        },
        {
          floor: 1,
          id: 'menu_notification',
          label: t(s_mypage_nav.notification),
          href: urls.student.portal.mypage.notification,
        },
        {
          floor: 2,
          id: 'menu_faq',
          label: t(s_menu.mypage.faq),
          href: urls.student.landing.faq,
          none: false,
        },
        {
          floor: 2,
          id: 'menu_notice',
          label: t(s_menu.mypage.notice),
          href: urls.student.landing.notice,
        },
        {
          floor: 2,
          id: 'menu_zoom',
          label: t(s_menu.mypage.zoom_install),
          href: urls.student.portal.mypage.zoom,
          none: false,
        },
      ],
      mypageMulticampus: [
        {
          floor: undefined,
          id: 'menu_credit',
          label: t(s_menu.mypage.coupon_certificates),
          href: urls.student.portal.mypage.currentCredit(0),
          none: false,
        },
        {
          floor: undefined,
          id: 'menu_profile',
          label: t(s_menu.mypage.my_info),
          href: urls.student.portal.mypage.profile,
          none: false,
        },
        {
          floor: undefined,
          id: 'menu_zoom',
          label: t(s_menu.mypage.zoom_install),
          href: urls.student.portal.mypage.zoom,
          none: false,
        },
        {
          floor: 2,
          id: 'menu_zoom',
          label: t(s_menu.mypage.zoom_install),
          href: urls.student.portal.mypage.zoom,
          none: false,
        },
      ],
    },
  }
}
